exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sidebox__sidebox___3KkfF{background-color:#fef1e8;padding:20px}.sidebox__sidebox___3KkfF h3,.sidebox__sidebox___3KkfF h4{margin-top:0;font-weight:700}", ""]);

// exports
exports.locals = {
	"sidebox": "sidebox__sidebox___3KkfF"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/components/styles/sidebox.scss
// module id = 1076
// module chunks = 0